module.exports = __webpack_public_path__ + "media/assets/test-9838d8b4c0bb25b64cee6a237024f5bd.svg";